import { ApiPathsService } from '../../api-paths.service';
import { ApiRestService  as ListinoApiRestService} from '../../listino/api-rest.service';
import { ApiRestService} from '../../Progetti/_services/api-rest.service';
import { FileStoreService } from '../../shared/_services/file-store.service';
import { Prodotto } from '../../Progetti/Models/Prodotto';
import { ProdottiStoreService } from '../../Progetti/_services/prodotti-store.service';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject, Subscription} from 'rxjs';
import { FormBuilder, FormGroup} from '@angular/forms';
import { ServerPaginationService } from 'src/app/shared/_services/server-pagination.service';
import {Permission} from "../../Login/_guards/Permission";
import { environment } from 'src/environments/environment';
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {CampoAggiuntivo, CampoUtility} from "../../shared/models/campo-aggiuntivo";
import {Color, hsl} from "d3";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ImportScontiComponent} from "../import-sconti/import-sconti.component";
import {ToastrService} from "ngx-toastr";
import {DownloadService} from "../../shared/_services/download.service";
import {AuthenticationService} from "../../Login/_services/authentication.service";
import {HttpHeaders} from "@angular/common/http";
import {ImportAccessoriComponent} from "../import-AccessoriGiemme/import-accessori.component";
import {ImportProdottiComponent} from "../import-Prodotti/import-prodotti.component";
import { DynamicEditComponent } from 'src/app/shared/dynamic-edit/dynamic-edit.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-lista-prodotti',
  templateUrl: './lista-prodotti.component.html',
  styleUrls: ['./lista-prodotti.component.scss']
})
export class ListaProdottiComponent implements OnInit {
  environment = environment;
  subscriptions: Subscription = new Subscription();
  showAllText: string = "Mostra Eliminati"
  showAllUser: boolean = false;
  type = ""
  ricercaform: FormGroup;
  submittedricerca;
  collectionSize = 0;
  page = 1;
  pageSize: number = 100;
  pagesizeserver = 4; // pagine da precaricare dal server
  newpagegenerated: number;
  @Input() Modale:boolean = false;
  @Input() Tipo : number;
  @Input() Prodotti: Prodotto[] = [];
  @Input() HasHeader: boolean = true;
  @Input() HasFilter: boolean = true;
  @Input() HasPaginazione: boolean = true;
  @Input() HasEliminatiButton: boolean = true;
  @Input() HasAddButton: boolean = true;
  @Input() externalAddFunction: boolean = false;
  @Input() HasEditButton: boolean = true;
  @Input() externalEditFunction: boolean = false;
  @Input() HasDeleteButton: boolean = true;
  @Input() externalDeleteFunction: boolean = false;
  @Input() HasRestoreButton: boolean = true;
  @Input() externalRestoreFunction: boolean = false;
  @Input() HasOpenButton: boolean = true;
  @Input() externalOpenFunction: boolean = false;
  @Input() Editable: boolean = true;
  @Input() ListType: 'prodotti' | 'listino' = 'prodotti';
  @Input() idListino: number;
  @Output() AddClicked = new EventEmitter();
  @Output() UpdateClicked = new EventEmitter<Prodotto>();
  @Output() DeleteClicked = new EventEmitter<Prodotto>();
  @Output() RestoreClicked = new EventEmitter<Prodotto>();
  @Output() OpenClicked = new EventEmitter<Prodotto>();
  id_tipo: string;
  filtri: any = {};
  querystring: any;
  querystringParams: string[] = [];
  DropdownSources: any = {stato: []};
  public debouncedInputValue = null;
  private searchDecouncer$: Subject<string> = new Subject();
  toggleOrdinamentoProdoti = false;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private progettistore: ProdottiStoreService,
    private paginationService: ServerPaginationService,
    private formBuilder: FormBuilder,
    private downloadService: DownloadService,
    private filestore: FileStoreService,
    private authSvc: AuthenticationService,
    public apiPaths: ApiPathsService,
    public permission: Permission,
    private listinoApiRestService: ListinoApiRestService,
    private ApiRestService: ApiRestService,
    public campoUtility: CampoUtility,
    private modalService: NgbModal,
    private toastrService: ToastrService,
    private datepipe: DatePipe
  ) {
    this.ricercaform = this.formBuilder.group({
      cerca: [''],
      size: [this.pageSize],
    });

  }

  get f() {
    return this.ricercaform.controls;
  }
  productIndex(prod: Prodotto) {
    return  this.Prodotti.findIndex(x=>x.id == prod.id);
  }

  LightenColor(color: Color, percent = 50) {
    var num = parseInt(color.toString().replace("#", ""), 16);
    if (num < 16750000)
      return hsl(0, 0, 100);
    else
      return hsl(0, 0, 0);
  };

  IsArray(val) {
    return val && Array.isArray(val);
  }

  ngOnInit() {
    console.log(this.ListType)
    this.HasHeader = (this.environment.ProdottiAddOn['HasHeader'] != undefined && this.HasHeader == true) ? this.environment.ProdottiAddOn['HasHeader'] : this.HasHeader;
    this.HasFilter = (this.environment.ProdottiAddOn['HasFilter'] != undefined && this.HasFilter == true) ? this.environment.ProdottiAddOn['HasFilter'] : this.HasFilter;
    this.HasPaginazione = (this.environment.ProdottiAddOn['HasPaginazione'] != undefined && this.HasPaginazione == true) ? this.environment.ProdottiAddOn['HasPaginazione'] : this.HasPaginazione;
    this.HasEliminatiButton = (this.environment.ProdottiAddOn['HasEliminatiButton'] != undefined && this.HasEliminatiButton == true) ? this.environment.ProdottiAddOn['HasEliminatiButton'] : this.HasEliminatiButton;
    this.HasAddButton = (this.environment.ProdottiAddOn['HasAddButton'] != undefined && this.HasAddButton == true) ? this.environment.ProdottiAddOn['HasAddButton'] : this.HasAddButton;
    this.HasEditButton = (this.environment.ProdottiAddOn['HasEditButton'] != undefined && this.HasEditButton == true) ? this.environment.ProdottiAddOn['HasEditButton'] : this.HasEditButton;
    this.HasDeleteButton = (this.environment.ProdottiAddOn['HasDeleteButton'] != undefined && this.HasDeleteButton == true) ? this.environment.ProdottiAddOn['HasDeleteButton'] : this.HasDeleteButton;
    this.HasRestoreButton = (this.environment.ProdottiAddOn['HasRestoreButton'] != undefined && this.HasRestoreButton == true )? this.environment.ProdottiAddOn['HasRestoreButton'] : this.HasRestoreButton;
    
    this.setupSearchDebouncer();
    if (this.ListType == "prodotti") {
      this.progettistore.getCategorieProdotti();
      this.progettistore.getUnitaDiMisura();// TODO: walkaround pe lista unita
      this.route.params.subscribe(data => {
        this.type = data['type'];
        this.id_tipo = this.Tipo ?? data['id_tipo'];
        this.route.queryParams
          .subscribe(params => {
              this.querystring = params;
              Object.getOwnPropertyNames(params)?.forEach(prop => {
                this.querystringParams.push(prop);
                this.filtri[prop] = params[prop];
                console.log('copy ' + params[prop] + ' to ' + 'this.filtri.' + prop)
              })
              this.refreshTable(1);
            }
          );
      })
      this.subscriptions.add(this.progettistore.$showAllProdotti.subscribe(data => this.showAllUser = data));
      this.subscriptions.add(this.progettistore.$prodotti.subscribe(data => {
        if(this.environment.ProdottiAddOn['mapProduct'])
          this.Prodotti = this.environment.ProdottiAddOn['mapProduct'](data?.data);
          else
        this.Prodotti = data?.data?.map(x => {
          if(this.environment.ProdottiAddOn['taglie'])
          {
            x['magazzino'] = x.taglie?.map(x => x.magazzino)?.reduce((acc, cur) => acc + cur, 0)?? 0;
          }
          return x;
        })??[];
        this.collectionSize = data.total;
      }));
    }
    if (this.ListType == "listino") {
      this.refreshTable(1);
    }
  }

  showfilter(filtro): boolean {
    return !filtro.oggetti.some(x => this.querystringParams.includes(x));
  }

  showDeleted() {
    this.progettistore.updateShowAllProdotti(!this.showAllUser);
    this.refreshTable(1);
    this.showAllText = this.showAllUser ? "Nascondi eliminati" : "Mostra eliminati"; //TODO: portare in html
  }

  sizeChanged() {
    this.pageSize = parseInt(this.f.size.value);
    this.refreshTable(1);
  }

  Search(filters?: any) {
    if (!(this.HasFilter && this.environment.ProdottiAddOn['prodottiFilter'])) {
      this.submittedricerca = true;
      if (this.ricercaform.invalid) {
        return;
      }
      this.refreshTable(1);
      this.submittedricerca = false;
    } else {
      this.refreshTable(1, filters);
    }
  }

  ImportaSconti() {
    let modale = this.modalService.open(ImportScontiComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ImportScontiComponent>modale.componentInstance).Uploaded.subscribe(data => {
      modale.dismiss();
      this.toastrService.success('Codici Importati con successo')
      this.refreshTable(1);
    });
  }

  public onSearchInputChange(): void {
    this.searchDecouncer$.next(this.filtri);
  }

  private setupSearchDebouncer(): void {
    this.searchDecouncer$.pipe(
      debounceTime(500),
      //distinctUntilChanged(),
    ).subscribe((term: any) => {
      this.debouncedInputValue = term;
      console.log('debouncedInputValue', term)
      this.Search(term);
    });
  }

  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }

  refreshTable(page, filters?: any) {
    if (this.ListType == "prodotti") {
      console.log('pagina generata', this.newpagegenerated)
      var filter = filters ?? this.filtri;
      environment.ProdottiAddOn['prodottiFilter']?.filter(x=> x.type == 'hidden' && (!x.filtertype || x.filtertype == this.id_tipo)).forEach(x => {
        filter[x.oggetti[0]] = x['value'];
      })
      this.progettistore.getProdotti(this.requestdata(page, filter));
    }
    if (this.ListType == "listino") {
      console.log('pagina generata', this.newpagegenerated)
      this.listinoApiRestService.ProdottiListinoProdotti({
        page: (page - 1) / this.pagesizeserver + 1,
        size: this.pagesizeserver * this.pageSize,
        id: this.idListino
      }).subscribe(data => {
        this.Prodotti = data.data;
        this.collectionSize = data.total;
      });
    }
  }

  requestdata(page, filters?: any): Prodotto {
    var prodotto: any = {
      page: (page - 1) / this.pagesizeserver + 1,
      size: this.pagesizeserver * this.pageSize,
      cat_id: this.type ? parseInt(this.type) : null,
      prodotto: this.f?.cerca?.value,
      tipo: filters.tipo ?? (this.id_tipo ? parseInt(this.id_tipo) : null),

    }
    if (filters)
      environment.ProdottiAddOn['prodottiFilter']?.forEach(filtro => prodotto[filtro.oggetti[0]] = filters[filtro.oggetti[0]])

    return prodotto;

    // return new Prodotto((page - 1) / this.pagesizeserver +1, this.pagesizeserver * this.pageSize, parseInt(this.type), undefined, this.f?.cerca?.value,null,null,null,null,null,null, );
  }

  delete(value: Prodotto) {
    if (confirm("Sicuro di voler eliminare questo elemento dalla lista?")) {
      if (this.externalDeleteFunction)
        this.DeleteClicked.emit(value);
      else
        this.progettistore.deleteItem(this.requestdata(1, this.filtri), value);
    }
  }

  renew(value) {
    if (this.externalRestoreFunction)
      this.RestoreClicked.emit(value);
    else
      this.progettistore.renewItem(this.requestdata(1, this.filtri), value);
  }

  edit(value) {
    if (this.externalEditFunction)
      this.UpdateClicked.emit(value);
    else if (value.tipoObject.id == 50 && this.permission.isPermitted('gestione-prodotti')) {
      this.router.navigate([this.route.snapshot.queryParams['progetti/codicisconto/editor/50/' + value.id] || 'progetti/codicisconto/editor/50/' + value.id,]);
    }else if (value.tipoObject.id == 69 && this.permission.isPermitted('gestione-prodotti')) {
      this.router.navigate([this.route.snapshot.queryParams['progetti/codicisconto/editor/69/' + value.id] || 'progetti/codicisconto/editor/69/' + value.id,]);
    } else if (this.permission.isPermitted('gestione-prodotti'))
      this.router.navigate([this.route.snapshot.queryParams['progetti/prodotti/editor/' + value.id] || 'progetti/prodotti/editor/' + value.id,]);
  }

  translations(value) {
    if (this.permission.isPermitted('gestione-prodotti'))
      this.router.navigate([this.route.snapshot.queryParams['progetti/product/translations/' + value.id] || 'progetti/product/translations/' + value.id,]);
  }

  add() {
    if (this.externalAddFunction)
      this.AddClicked.emit();
    else if (this.id_tipo && this.permission.isPermitted('gestione-prodotti') && this.id_tipo != '68') {
      this.router.navigate([this.route.snapshot.queryParams['progetti/codicisconto/editor/' + this.id_tipo] || 'progetti/codicisconto/editor/' + this.id_tipo,]);
    } else if (this.permission.isPermitted('gestione-prodotti'))
      this.router.navigate([this.route.snapshot.queryParams['progetti/prodotti/editor/'] || 'progetti/prodotti/editor/',]);
  }
  Add(item){
    this.AddClicked?.emit(item);
  }

  Open(co) {
    if (this.externalOpenFunction)
      this.OpenClicked.emit(co);
    else
      this.router.navigate([this.route.snapshot.queryParams['ecom/details/' + co.id] || 'ecom/details/' + co.id,]);
  }

  getprice(prodotto: Prodotto) {
    return prodotto && isNaN(prodotto.prezzo) && prodotto?.prezzi?.length > 0 ? prodotto?.prezzi[0]?.prezzo?.toString() + '€/' + prodotto?.prezzi[0].umlabel : prodotto?.prezzo?.toString() + '€';
  }

  Copy(prodotto: Prodotto) {
    this.ApiRestService.getInfoProdotto({id: prodotto?.id}).subscribe(data => {
      if (environment.ProdottiAddOn.codice)
        data.codice += " Copia"
      data.prodotto += " Copia"
      data.slug = "";
      var catstored = data.categorie;
      data.categorie = catstored.map(x => x.id);
      this.progettistore.addNewItem(data).subscribe(() => this.refreshTable(this.newpagegenerated && this.newpagegenerated > 1 ? this.newpagegenerated : 1));
    });
  }

  ReverseStandby(prodotto: Prodotto) {
    this.ApiRestService.getInfoProdotto({id: prodotto?.id}).subscribe(data => {
      data.standby = !data.standby;
      var catstored = data.categorie;
      data.categorie = catstored.map(x => x.id);
      this.ApiRestService.updateProdotti(data).subscribe(() => this.refreshTable(this.newpagegenerated && this.newpagegenerated > 1 ? this.newpagegenerated : 1));
    });
  }

  getids(value: any[]): number[] {
    const Output: number[] = [];
    value?.forEach(item => Output.push(item.id));
    return Output;
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.Prodotti, event.previousIndex, event.currentIndex);
    this.ApiRestService.OrderProdotti(this.Prodotti).subscribe(() => this.refreshTable(this.newpagegenerated ?? 1));
  }

  selectChange(search: string, $event: any, CampoAggiuntivo: any) {
    if (CampoAggiuntivo.OutputField) {
      this.filtri[CampoAggiuntivo.OutputField] = $event?.id ?? null;
      console.log(`selected id: ${$event?.id} copied to ${CampoAggiuntivo.OutputField}: ${this.filtri[CampoAggiuntivo.OutputField]}`);
    }
    else if (CampoAggiuntivo.OutputField && !CampoAggiuntivo?.settings?.singleOutput) {
      this.filtri[CampoAggiuntivo.OutputField] = $event?.map(x => x.id) ?? null;
      console.log(`selected ids: ${$event?.map(x => x.id)} copied to ${CampoAggiuntivo.OutputField}: ${this.filtri[CampoAggiuntivo.OutputField]}`);
    }
    else if (CampoAggiuntivo.OutputObject) {
      this.filtri[CampoAggiuntivo.OutputObject] = $event ?? null;
      console.log(`selected value: ${$event} copied to ${CampoAggiuntivo.OutputObject}: ${this.filtri[CampoAggiuntivo.OutputObject]}`);
    }
    this.onSearchInputChange();
  }

  getCampoAggiuntivoArray(CampoAggiuntivo: any) {
    return [CampoAggiuntivo];
  }

  DownloadReport() {
    var restroute = this.id_tipo == '50' ? '/prodotti/report/coupon' : '/prodotti/report'
    var header = new HttpHeaders();
    this.apiPaths.ClassicGet(restroute, {
      headers: header,
      observe: 'response',
      responseType: 'blob'
    }).subscribe(data => {
      this.downloadService.downloadFile(data);
    });
  }

  Importa() { //accessori giemmea
    let modale = this.modalService.open(ImportAccessoriComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ImportAccessoriComponent>modale.componentInstance).Uploaded.subscribe(data => {
      modale.dismiss();
      this.toastrService.success('Importati con successo')
      this.refreshTable(1);
    });
  }

  ListClick(item: Prodotto, campo: any) {
    if (!campo.modificabile && this.HasEditButton)
      this.edit(item);
  }
  customButton(button: { type?: 'GET'| 'POST'| string, restRoute?: string, preMex?: string, successMex?: string, parameter?: any[], preAlert: string, noClose?: boolean, parameterInArray?: boolean}, item: Prodotto) {
    if(item && (!button.preAlert || confirm(button.preAlert))){
        var filter ={};
        button.parameter?.forEach(param=>{
          var p = param?.parameter?.split('.');
          var parameter = Object.assign({}, item)
          p?.forEach(el=>{
            parameter = parameter ? parameter[el]: null;
          })
          filter[param.nome] = param.value ?? parameter
        })
        if(button.parameterInArray)
          filter = [filter];
        if(button.preMex)
          this.toastrService.warning(button.preMex);
        if(button.type == 'GET' && button.restRoute)
          this.apiPaths.ClassicGet(button.restRoute).subscribe(data=>{
            if(button.successMex)
              this.toastrService.success(button.successMex);
            this.refreshTable(1);
          })
        if(button.type == 'POST' && button.restRoute)
          this.apiPaths.ClassicPost(button.restRoute,filter).subscribe(data=>{
            if(button.successMex)
              this.toastrService.success(button.successMex);
            this.refreshTable(1);
          })
          if(button.type == 'Prendi'){
            const EditModal = this.modalService.open(DynamicEditComponent, {
              centered:true,
              backdrop: 'static',
              size: 'xl'
          });
          (<DynamicEditComponent>EditModal.componentInstance).CrudSettings = {
            HasAddList: {},//da usare come hideif
            Capacita: ['gestione-struttura'],
            initObj:[
              {campo: 'alert_inizio_task', value: 0},
              {campo: 'alert_fine_task', value: 0},
              {campo:'data_inizio_effettiva', tipo:'date'},
              {campo:'data_inizio_prevista', tipo:'date'},
            ],
            Id: "strutture",
            RestRoute: '/rma/interventi',
            ListResponseHasData: true,
            GetResponseHasData: false,
            HasGet: false,
            ListDefaultFilter: {},
            OnSaveMap: (x)=>{{
              var prodotto = x;
              var dataRestituzione = new Date();
              dataRestituzione.setDate(dataRestituzione.getDate() +20);
              var rma:any = {};
              rma.data_inizio_effettiva = this.datepipe.transform(new Date(), 'yyyy-MM-ddT00:00');
              rma.data_inizio_prevista = this.datepipe.transform(new Date(), 'yyyy-MM-ddT00:00');
              rma.alert_inizio_task = 0;
              rma.alert_fine_task = 0;
              rma.data_fine_prevista = this.datepipe.transform(dataRestituzione, 'yyyy-MM-ddTHH:mm');
              rma.nome = `Prestito libro: ${prodotto.prodotto}`;
              rma.cliente = x.cliente;
              rma.accessoriObject = [
                {
                  id: prodotto.id,
                  nome: prodotto.prodotto,
                  prodotto: prodotto.prodotto,
                  quantita: 1,
                  valore: prodotto.prezzo,
                  magazzino: this.filtri.magazzino ?? x.magazzino,
                  stampa: null,
                  scarico: true,
                  carico: false
                }
              ]
            
              return rma
            }},
            MenuItems:[
            ],
            campi: [
              {
                nome: 'Utente',
                required: true,
                source: '/anagrafica/clienti/list',
                parameter: [{nome: "page", value: 1}, {nome: "size", value: 200}, {
                  nome: "ruolo",
                  value: 'C'
                }],
                oggetti: ['cliente'],
                internalOutput: 'clienteObject',
                responseHasData: true,
                OutputField: 'cliente',
                OnChange: 'clienteObjectchange',
                modificabile: true,
                inputType: 'singleDropdown',
                placeholder: 'Seleziona',
                settings: {
                  singleSelection: true,
                  closeDropDownOnSelection: true,
                  singleOutput: true,
                  idField: 'id',
                  textField: 'fullName',
                  searchPlaceholderText: "Cerca",
                  allowSearchFilter: true,
                  allowRemoteDataSearch: false,
                },
                class: 'col-lg-6',
                visibleifProhibited: true
              },
             ...(this.filtri.magazzino ?[]: [ {
              nome: 'Teca',
              required: true,
              source: '/prodotti/magazzini/list/all',
              parameter: [{nome: "page", value: 1}, {nome: "size", value: 200}],
              oggetti: ['magazzino'],
              internalOutput: 'magazzinoObject',
              responseHasData: true,
              OutputField: 'magazzino',
              OnChange: 'magazzinoObjectchange',
              modificabile: true,
              inputType: 'singleDropdown',
              placeholder: 'Seleziona',
              settings: {
                singleSelection: true,
                closeDropDownOnSelection: true,
                singleOutput: true,
                idField: 'id',
                textField: 'nome',
                searchPlaceholderText: "Cerca",
                allowSearchFilter: true,
                allowRemoteDataSearch: false,
              },
              class: 'col-lg-6',
              visibleifProhibited: true
            },])
            ],
            Azioni: [
            ],
            Headers: [
            ],
            Filters:[],
          };
          (<DynamicEditComponent>EditModal.componentInstance).Item = item ;
          (<DynamicEditComponent>EditModal.componentInstance).updated.subscribe(data => {
              this.refreshTable(1);
          });
          }
          if(button.type == 'Restituisci'){
            const EditModal = this.modalService.open(DynamicEditComponent, {
              centered:true,
              backdrop: 'static',
              size: 'xl'
          });
          (<DynamicEditComponent>EditModal.componentInstance).CrudSettings = {
            HasAddList: {},//da usare come hideif
            Capacita: ['gestione-struttura'],
            initObj:[
            ],
            Id: "strutture",
            RestRoute: '/rma/interventi',
            ListResponseHasData: true,
            GetResponseHasData: false,
            HasGet: false,
            ListDefaultFilter: {},
            OnSaveMap: (x)=>{{
              var prodotto = x;
              var dataRestituzione = new Date();
              var rma:any = x.rma.find(y => !y.data_fine_effettiva && y.scarico);
              
              if(rma){
                rma.data_fine_effettiva = this.datepipe.transform(new Date(), 'yyyy-MM-ddT00:00');
              } else {
                this.toastrService.warning('non sono stati trovati prestiti in corso per questo libro','Attenzione')
              }
              return rma
            }},
            MenuItems:[
            ],
            campi: [
              {
                nome: 'Teca',
                required: true,
                source: '/prodotti/magazzini/list/all',
                parameter: [{nome: "page", value: 1}, {nome: "size", value: 200}],
                oggetti: ['magazzino'],
                internalOutput: 'magazzinoObject',
                responseHasData: true,
                OutputField: 'magazzino',
                OnChange: 'magazzinoObjectchange',
                modificabile: true,
                inputType: 'singleDropdown',
                placeholder: 'Seleziona',
                settings: {
                  singleSelection: true,
                  closeDropDownOnSelection: true,
                  singleOutput: true,
                  idField: 'id',
                  textField: 'nome',
                  searchPlaceholderText: "Cerca",
                  allowSearchFilter: true,
                  allowRemoteDataSearch: false,
                },
                class: 'col-lg-6',
                visibleifProhibited: true
              },
             
            ],
            Azioni: [
            ],
            Headers: [
            ],
            Filters:[],
          };
          (<DynamicEditComponent>EditModal.componentInstance).Item = item ;
          (<DynamicEditComponent>EditModal.componentInstance).updated.subscribe(data => {
              this.refreshTable(1);
          });
          }
    }

  }

  ImportaExcel() {
    let modale = this.modalService.open(ImportProdottiComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ImportProdottiComponent>modale.componentInstance).Tipo = this.id_tipo;
    (<ImportProdottiComponent>modale.componentInstance).Uploaded.subscribe(data => {
      modale.dismiss();
      this.toastrService.success('Importati con successo')
      this.refreshTable(1);
    });
  }
  ImportaDynamic(importInfo) {
    var campi: CampoAggiuntivo[] = importInfo.campi;
    let modale = this.modalService.open(ImportProdottiComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ImportProdottiComponent>modale.componentInstance).Tipo = this.id_tipo;
    (<ImportProdottiComponent>modale.componentInstance).restRoute = importInfo.url;
    (<ImportProdottiComponent>modale.componentInstance).campiImport = campi;
    (<ImportProdottiComponent>modale.componentInstance).Uploaded.subscribe(data => {
      modale.dismiss();
      this.toastrService.success('Importati con successo')
      this.refreshTable(1);
    });
  }
  closeModal(){
    this.modalService.dismissAll();
  }
}
